import React from 'react';
import { Input } from 'antd';

import { Label } from 'components';

const { TextArea } = Input;

const TextAreaField = ({ label, asterisk, rows, customLabelClass, ...rest }) => {
  return (
    <>
      <Label label={label} asterisk={asterisk} customClass={customLabelClass}/>
      <TextArea {...rest} rows={rows || 6} />
    </>
  );
};

export default TextAreaField;
